module.exports = __webpack_public_path__ + "img/16.b3bd8d5c.png";